/**
 * Put text on the clipboard. Browsers allow it in a secure context (https, localhost, the native
 * apps) during a user's click; false when they refuse, so the caller can say so.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
